import React from 'react'
import Helmet from "react-helmet"
import config from '../website-config';
import "../styles/BooksSummaryStyles/css/style.css"
import Header from '../components/website/Header/Header'
import Footer from "../components/website/Footer/Footer";
import Copyright from "../components/website/Copyright/Copyright";

const BookLayout: React.FC = props => {
  return ((
    <div>
      <Helmet>
        <html lang={config.lang} />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no" />
        <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
        <meta property="og:site_name" content={config.title} />
        {/* <meta charset="UTF-8" /> */}
        <link rel="shortcut icon" href='../favicon.png' />
        <meta name="apple-mobile-web-app-title" content={config.title}/>
        <meta name="application-name" content={config.title}/>
        <meta property="og:image" content='https://bizdamn.tech/meta-image.png' />
        <meta property="og:image:url" content="https://bizdamn.tech/meta-image.png" />
        <meta property="og:image:alt" content="BizDamn - Best Web Development, Digital Marketing and Graphic Designing Services" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:image:type" content="images/png" />
        <meta name="p:domain_verify" content="ca4835005f921d90990bb40266003a74"/>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content='Twitter @biz_damn' />
        <meta name="twitter:description" content={config.description} />
        <meta name="twitter:url" content={config.siteUrl} />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet"/>
        <meta name="twitter:image" content='https://bizdamn.tech/meta-image.png' />
        {config.facebook && <meta property="article:publisher" content={config.facebook} />}
        {config.googleSiteVerification && (
          <meta name="google-site-verification" content={config.googleSiteVerification} />
        )}

        {config.twitter && (
          <meta name="twitter:site" content={`@${config.twitter.split('https://twitter.com/')[1]}`} />
        )}
       
       <link onload="this.media='all'" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/css/all.min.css"media="print" rel="stylesheet"/>

        <link  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/css/all.min.css" media="print" rel="stylesheet" />
        <script async src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js" type="text/javascript"></script>
        <script async src="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/3.6.0/mdb.min.js" type="text/javascript"></script>
        <script type="application/ld+json">
       {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "url": "${config.siteUrl+'/books-summary'}",
          "name":"Books Summary | ",
          "description":"${config.description}",
          "logo": "${config.siteUrl}/${config.logo}"
        },
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "url": "${config.siteUrl}",
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": "${config.siteUrl}/search?q={search_term_string}"
            },
            "query-input": "required name=search_term_string"
          }
          `}
    </script> 
 
      </Helmet>

      <Header />
      <div className="content">
        {props.children}
      </div>
      <Footer />
      <Copyright />
    </div>
  )

  )
}


export default BookLayout;






